import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingServicedeskResolutionManagementRoute: InvariantJiraRoute = {
	name: 'project-setting-servicedesk-resolution-management',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/resolution-management',
	exact: true,
};
